import React, { FC } from 'react'
import QRCode from 'qrcode.react'
import { observer } from 'mobx-react'
import { storeMobx } from '@mobxStore'
import './index.scss'

import imgT from '@img/phone/phone_t.png'
import imgC from '@img/phone/phone_c.png'
import imgB from '@img/phone/phone_b.png'
import bg1 from '@img/phone/bg_1.jpg'
import bg2 from '@img/phone/bg_2.jpg'
import bg3 from '@img/phone/bg_3.jpg'
import bg4 from '@img/phone/bg_4.jpg'
import bg5 from '@img/phone/bg_5.jpg'
import bg6 from '@img/phone/bg_6.jpg'
import bg7 from '@img/phone/bg_7.jpg'
import bg8 from '@img/phone/bg_8.jpg'

const bgObj: any = {
  1: bg1,
  2: bg2,
  3: bg3,
  4: bg4,
  5: bg5,
  6: bg6,
  7: bg7,
  8: bg8,
}
// interface
interface IProps extends React.HTMLAttributes<HTMLDivElement> {
  children: any;
}

const PhoneCase: FC<IProps> = (props: IProps) => {
  const url = `${location.origin}/store${location.search}`
  const bgNumber: number = Math.floor(Math.random() * 8 + 1)
  return (
    <div className='phone-window'>
      <div className='window-top'>
        <div className={`window-top-img${!storeMobx.brand.extInfo?.promotionBackground ? ' system' : ''}`} style={{ backgroundImage: `Url(${storeMobx.brand.extInfo?.promotionBackground || bgObj[bgNumber]})` }}></div>
        <div className='phone-area'>
          <div className='phone-top' style={{ backgroundImage: `Url(${imgT})` }}></div>
          <div className='phone-center' style={{ backgroundImage: `Url(${imgC})` }}></div>
          <div className='phone-top' style={{ backgroundImage: `Url(${imgB})` }}></div>
          <div className='phone-app-area'>
            <iframe className='phone-app-iframe' src={`${window.prePage}&source=phoneCase`} frameBorder='0'></iframe>
          </div>
          {
            screen.width > 1024 &&
              <div className='phone-er-area'>
                <div className='er-code'>
                  <QRCode size={176} title={url} value={url} />
                </div>
                <div className='er-des'>
                  <span>{i18n.t('common.mobileIsBetter')}</span>
                </div>
              </div>
          }
        </div>
      </div>
    </div>
  )
}

export default observer(PhoneCase)
